import classNames from 'classnames'
import { useChangeLocale } from '../../modules/apis/common/user'
import { useCurrentUser } from '../../modules/context/UserContext'
import {
  LOCALE_EN,
  LOCALE_JA,
  LOCALE_KO,
  LOCALE_VI,
  LOCALE_ZH_CHS,
  LOCALE_ZH_CHT,
  LocaleType,
} from '../../modules/i18n/config'
import useTranslation from '../../modules/i18n/useTranslation'

interface LanguageToggleProps {
  noPadding?: boolean
  koEnOnly?: boolean
  currentLang: LocaleType
  handleSwitchLocale?: (key: LocaleType) => void
}

const LanguageToggle = ({
  noPadding = false,
  koEnOnly = false,
  currentLang,
  handleSwitchLocale = null,
}: LanguageToggleProps) => {
  const locales = [
    {
      name: 'ENG',
      key: LOCALE_EN,
    },
    {
      name: '한국어',
      key: LOCALE_KO,
    },
    {
      name: '中文（简体）',
      key: LOCALE_ZH_CHS,
    },
    {
      name: '中文（繁體）',
      key: LOCALE_ZH_CHT,
    },
    {
      name: '日本語',
      key: LOCALE_JA,
    },
    {
      name: 'tiếng Việt',
      key: LOCALE_VI,
    },
  ]
  const { currentUser } = useCurrentUser()
  const { mutate } = useChangeLocale()
  const { updateLandingLocale } = useTranslation()

  const handleOnChangeLocale = (targetLocale: LocaleType) => {
    if (handleSwitchLocale) {
      handleSwitchLocale(targetLocale)
      return
    }

    if (currentUser) {
      mutate({ locale: targetLocale })
    } else {
      updateLandingLocale(targetLocale)
    }
  }

  if (koEnOnly) {
    locales.splice(2)
  }
  return (
    <div className={classNames({ rounded: 5 }, koEnOnly && 'flex flex-row', 'border p-2 transition-colors')}>
      {locales.map((item, i) => (
        <div
          key={`locale${i}`}
          onClick={() => handleOnChangeLocale(item.key)}
          className={classNames(
            [
              currentLang != item.key && 'text-gray-500',
              currentLang == item.key && 'bg-purple-50 text-purple-500',
              noPadding && 'pl-0 pr-0',
              !noPadding && 'px-24',
            ],
            'text-h5 flex flex-1 cursor-pointer items-center justify-center whitespace-nowrap rounded-[5px] py-[4px] font-normal'
          )}
        >
          {item.name}
        </div>
      ))}
    </div>
  )
}
export default LanguageToggle
